import * as yup from 'yup';

export const schema = yup.object().shape({
   uf: yup.string(),
   usuario: yup.string(),
   chassi: yup.string(),
   numeroContrato: yup.string(),
   dataInicio: yup.string(),
   dataFim: yup.string(),
   intituicaoFinanceira: yup.string()
});